// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Bfm0","error":"Textarea_error___deHy","readonly":"Textarea_readonly__21GW7","disabled":"Textarea_disabled__2BLZP"};